// Module
var code = "<template> <require from=\"./signing.scss\"></require> <page name=\"signing\"> <iframe name=\"signing-iframe\" src=\"${signingUrl}\"> </iframe> </page> </template> ";
// Exports
module.exports = code;